import {QueryParams} from "../types";
import api, {create, deleteOne, getAll, getOne, listAll, update} from "./api";

const endpoint = '/banner';

export default {
    all: async (params?: QueryParams) => getAll<any>({endpoint, params}),
    listAll: async () => listAll<any>({endpoint}),
    one: async (id: any, relations?: string) => getOne<any>({endpoint, id, relations}),
    destroy: async (id: string) => deleteOne({endpoint, id}),
    create: async (formData: Partial<any>) => create<any>({endpoint, formData}),
    update: async (id: string, formData: Partial<any>) => update<any>({ endpoint, formData, id }),

    /*async getVehiclesHome(params?: QueryParams){
        try {
            const page    = params?.page    ? 'page='    + params?.page    : 'page=1';
            const perPage = params?.perPage ? '&perpage=' + params?.perPage : '';
            const relations = params?.relations ? '&relations=' + params?.relations : '';
            const whereBig = params?.whereBig ? '&'+params?.whereBig : '';
            const {data} = await api.get(`${endpoint}/list?${page}${perPage}${relations}${whereBig}&order=id,desc`);
            return {data, isError: false};
        } catch (err: any) {
            return {
                data: err?.response?.data ?? {message: 'Falha ao processar requisição'},
                isError: true
            };
        }
    },

    async getVehiclesView(id:any){
        try {

            const {data} = await api.get(`${endpoint}/view/${id}`);
            return {data, isError: false};
        } catch (err: any) {
            return {
                data: err?.response?.data ?? {message: 'Falha ao processar requisição'},
                isError: true
            };
        }
    },*/
}